<template>
  <span style="text-align:left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-input
        :value="color"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <el-color-picker class="mt-1" :predefine="predefineColors" v-model="color"></el-color-picker>
      </v-input>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">
        <span :style="{ 'background-color': displayvalue }">&nbsp;&nbsp;&nbsp;</span>
        {{ displayvalue }}
      </span>
    </template>

    <template v-if="modo == 'filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="event => $emit('input', preUpdateFiltro(event))"
        :mask="getComponentParam('mask')"
        background-color="#fcfcfc"
      ></v-text-field>
    </template>
  </span>
</template>

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

export default {
  extends: _baseComponent,

  data() {
    return {
      color: this.value,
      predefineColors: [
        "#ffffff",
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
      ],
    };
  },
  methods: {},
  watch: {
    color() {
      this.$emit("input", this.color);
    },
    value() {
      this.color = this.value;
    },
  },
};
</script>

<style scoped></style>
